import { Component, Inject } from '@angular/core';
import { ButtonComponent } from "../components/common/components/button/button.component";
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { DashboardService } from '../services/shared/dashboard.service';

@Component({
  selector: 'app-on-prompt-delete',
  standalone: true,
  imports: [MatDialogModule, CommonModule, FormsModule, ButtonComponent],
  templateUrl: './on-prompt-delete.component.html',
  styleUrl: './on-prompt-delete.component.scss'
})
export class OnPromptDeleteComponent {
  title:string = ""
  promptId: any;
  promptDetailsStored: any;
  removeTab: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<OnPromptDeleteComponent>, private dialog: MatDialog, private dashboardService: DashboardService) {
    if (data) {
      this.title = data?.title;
      this.promptId = data?.promptId
      this.promptDetailsStored = data?.promptDetailsStored
      this.removeTab = data?.removeTab
    }
  }

  onClose(event: any): void {
    this.dialogRef.close(true);
  }

  onDelete(event: any, id: number): void {
    if (this.removeTab) {
      this.dialogRef.close('remove');
    } else {
      let delRes = this.dashboardService.promptDeleteApi(id).subscribe((res: any)=>{
        if(res.status_code == 200) {
          this.dialogRef.close({promptDelete: "success"});
        }
      })
      
      // this.dialogRef.close(true);
    }
  }



}
